module.exports = __webpack_public_path__ + "img/params.76cfcdd2.png";